import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (sessionId) {
        const user = await exchangeSession(sessionId);
        if (user) {
          // Clean the URL and redirect to dashboard
          window.history.replaceState(null, '', '/admin/dashboard');
          navigate('/admin/dashboard', { replace: true, state: { user } });
          return;
        }
      }

      // If no session_id or exchange failed, redirect to login
      navigate('/admin/login', { replace: true });
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-kairos-orange border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <h2 className="text-xl font-display text-white mb-2">Autenticando...</h2>
        <p className="text-gray-400">Por favor, aguarde</p>
      </div>
    </div>
  );
};

export default AuthCallback;
